import { render, staticRenderFns } from "./extraClass.vue?vue&type=template&id=a134a83c&scoped=true&"
import script from "./extraClass.vue?vue&type=script&lang=js&"
export * from "./extraClass.vue?vue&type=script&lang=js&"
import style0 from "./extraClass.vue?vue&type=style&index=0&id=a134a83c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a134a83c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
